import _createClass from '@babel/runtime/helpers/esm/createClass';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _createSuper from '@babel/runtime/helpers/esm/createSuper';
import _wrapNativeSuper from '@babel/runtime/helpers/esm/wrapNativeSuper';

var ReconcileApiExceptionType = /*#__PURE__*/function (ReconcileApiExceptionType) {
  ReconcileApiExceptionType["EmailAlreadyUsed"] = "https://api.landr.com/errors/EmailAlreadyUsed";
  return ReconcileApiExceptionType;
}({});
var AuthServiceCustomErrors = /*#__PURE__*/function (AuthServiceCustomErrors) {
  AuthServiceCustomErrors["ReconcileError"] = "reconcile_error";
  AuthServiceCustomErrors["CodeAndStateValidationError"] = "code_and_state_validation_error";
  AuthServiceCustomErrors["EmailAlreadyUsedError"] = "email_already_used_error";
  AuthServiceCustomErrors["AccessTokenRequestError"] = "access_token_request_error";
  return AuthServiceCustomErrors;
}({});
var OAuthError = /*#__PURE__*/function (_Error) {
  _inherits(OAuthError, _Error);
  var _super = _createSuper(OAuthError);
  function OAuthError(message, errorCode) {
    var _this;
    _classCallCheck(this, OAuthError);
    _this = _super.call(this, message);
    _this.errorCode = errorCode;
    return _this;
  }
  return _createClass(OAuthError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

export { AuthServiceCustomErrors, OAuthError, ReconcileApiExceptionType };
